import React from 'react';
import { Grid, Typography, Box, Divider } from '@mui/material';
import HandsOnMobile from '../assets/img/handsonmobile.jpg';
import useStyles from '../styles/styles';
import { useSelector } from 'react-redux';
import { FONT_FAMILY } from 'common/sharedFunctions';
import { useTranslation } from "react-i18next";

const DownloadApp = () => {
  const classes = useStyles();
  const settings = useSelector(state => state.settingsdata.settings);
const { t, i18n } = useTranslation();
const lang = i18n.language?.startsWith('de') ? 'de' : 'en';
const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

const DISTRICTS = [
  "1010","1020","1030","1040","1050","1060","1070","1080","1090",
  "1100","1110","1120","1130","1140","1150","1160","1170",
  "1180","1190","1200","1210","1220","1230"
];

const faqContent = {
  de: {
    title: "Häufige Fragen zur Taxi-App Ryyd",
    items: [
      {
        q: "Was ist Ryyd?",
        a: "Ryyd ist eine Taxi-Buchungsapp für Wien. Die App fungiert ausschließlich als digitale Bestell- und Vermittlungsplattform zwischen Fahrgästen und konzessionierten Taxiunternehmen."
      },
      {
        q: "Sehen Fahrer Fahrpreis und Fahrziel vor Annahme der Fahrt?",
        a: "Ja. Bei Ryyd sehen Fahrer bereits vor Annahme einer Fahrt sowohl das Fahrziel als auch den vorab berechneten Fahrpreis."
      },
      {
        q: "Wie wird der Fahrpreis bei Ryyd festgelegt?",
        a: "Der Fahrpreis wird vor Fahrtbeginn auf Basis des Wiener Taxitarifs berechnet. Dabei werden die geltenden Tarifregelungen, einschließlich Tag-, Nacht-, Sonn- und Feiertagstarife, berücksichtigt."
      },
      {
        q: "Warum kann der Ryyd-Fahrpreis von einem Taxameterpreis abweichen?",
        a: "Ein Taxameter berechnet den Fahrpreis während der Fahrt anhand von Faktoren wie Verkehrsaufkommen, Wartezeiten oder Streckenabweichungen. Da diese Faktoren im Voraus nicht exakt vorhersehbar sind, kann der vorab berechnete Ryyd-Fahrpreis von einem theoretischen Taxameterendpreis leicht abweichen."
      },
      {
        q: "Gibt es bei Ryyd dynamische Preiserhöhungen?",
        a: "Nein. Ryyd verwendet keine dynamischen oder nachfrageabhängigen Preisanpassungen, etwa bei hoher Nachfrage, zu Stoßzeiten oder bei besonderen Wetterlagen."
      },
      {
        q: "Müssen Fahrer bei Ryyd Provision oder Gebühren zahlen?",
        a: "Nein. Für Fahrer und Taxiunternehmen fallen bei Ryyd keine Provisionen oder laufenden Vermittlungsgebühren an."
      },
      {
        q: "Wodurch unterscheidet sich Ryyd von anderen Taxi-Apps in Wien?",
        a: "Ryyd unterscheidet sich dadurch, dass Fahrer bereits vor Annahme einer Fahrt Fahrziel und Fahrpreis kennen. Zudem basiert die Preisberechnung auf dem Wiener Taxitarif ohne dynamische Preisaufschläge oder provisionsbasierte Abrechnung."
      }
    ]
  },

  en: {
    title: "Frequently Asked Questions about the Ryyd Taxi App",
    items: [
      {
        q: "What is Ryyd?",
        a: "Ryyd is a taxi booking app for Vienna. The app operates solely as a digital booking and mediation platform between passengers and licensed taxi companies."
      },
      {
        q: "Do drivers see the fare and destination before accepting a ride?",
        a: "Yes. With Ryyd, drivers can see both the destination and the pre-calculated fare before accepting a ride request."
      },
      {
        q: "How is the fare determined on Ryyd?",
        a: "The fare is calculated before the ride begins based on the official Vienna taxi tariff. This includes applicable daytime, nighttime, Sunday, and public holiday rates."
      },
      {
        q: "Why can the Ryyd fare differ from a taximeter fare?",
        a: "A taximeter calculates the final fare during the ride based on factors such as traffic conditions, waiting time, and route deviations. Since these factors cannot be fully predicted in advance, the pre-calculated Ryyd fare may differ from a theoretical taximeter-based fare."
      },
      {
        q: "Does Ryyd use dynamic or surge pricing?",
        a: "No. Ryyd does not apply dynamic or demand-based price adjustments, such as surge pricing during peak hours, high demand, or adverse weather conditions."
      },
      {
        q: "Do drivers pay commission or fees when using Ryyd?",
        a: "No. Ryyd does not charge drivers or taxi operators any commission or recurring fees."
      },
      {
        q: "What differentiates Ryyd from other taxi apps in Vienna?",
        a: "Ryyd differs in that drivers know both the destination and the fare before accepting a ride. In addition, fares are calculated in accordance with the Vienna taxi tariff without dynamic pricing or commission-based models."
      }
    ]
  }
};


const currentFaq = faqContent[lang];

  return (
    <>
      {/* =========================
          ZEILE 1: BILD + DOWNLOAD
         ========================= */}
      <Box className={classes.aboutUsContainer}>
        <Grid
          container
          spacing={4}
          alignItems="center"
          className={classes.gridContainer}
        >
          {/* BILD */}
          <Grid item xs={12} md={6}>
            <img
              src={HandsOnMobile}
              alt="Ryyd Taxi App auf dem Smartphone"
              className={classes.largeImage}
            />
          </Grid>

          {/* TEXT + DOWNLOAD LINKS */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h3"
              fontWeight={700}
              fontFamily={FONT_FAMILY}
              className={classes.title}
            >
              {t('mobile_apps_on_store')}
            </Typography>

            <Typography
              fontFamily={FONT_FAMILY}
              className={classes.aboutUsSubtitle}
            >
              {t('app_store_deception1')}
            </Typography>

            <Box mt={3}>
              {settings?.AppleStoreLink && (
                <a href={settings.AppleStoreLink}>
                  <img
                    src={require('../assets/img/appstore.png')}
                    alt="Ryyd im Apple App Store"
                  />
                </a>
              )}

              <span style={{ marginRight: 10 }} />

              {settings?.PlayStoreLink && (
                <a href={settings.PlayStoreLink}>
                  <img
                    src={require('../assets/img/playstore.png')}
                    alt="Ryyd im Google Play Store"
                  />
                </a>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* =========================
          ZEILE 2: FAQ – VOLLE BREITE
         ========================= */}
      <Box
  component="section"
  mt={4}
  px={{ xs: 2, md: 6 }}
  maxWidth="1400px"
  mx="auto"
>
  <Divider sx={{ mb: 3 }} />

  <Typography
    variant="h4"
    fontWeight={700}
    fontFamily={FONT_FAMILY}
    gutterBottom
  >
    {currentFaq.title}
  </Typography>

  {currentFaq.items.map((item, index) => (
    <Box key={index} mb={2}>
      <Typography variant="h6" fontWeight={600}>
        {item.q}
      </Typography>
      <Typography paragraph>
        {item.a}
      </Typography>
    </Box>
  ))}
</Box>
{/* =========================
    SEO INTERNAL LINKS (A–Z + DISTRICTS)
   ========================= */}
<Box
  component="section"
  mt={6}
  px={{ xs: 2, md: 6 }}
  maxWidth="1400px"
  mx="auto"
>
  <Divider sx={{ mb: 3 }} />

  <Typography
    variant="h6"
    fontWeight={600}
    gutterBottom
  >
    Taxi Transfers in Vienna – Hotels & Districts
  </Typography>

  {/* A–Z */}
  <Box mb={2}>
    {ALPHABET.map(letter => (
      <a
        key={letter}
        href={`/transfer/${letter}`}
        style={{
          marginRight: 8,
          textDecoration: "none",
          color: "#1976d2",
          fontSize: 14
        }}
      >
        {letter}
      </a>
    ))}
  </Box>

  {/* DISTRICTS */}
  <Box>
    {DISTRICTS.map(plz => (
      <a
        key={plz}
        href={`/transfer/${plz}`}
        style={{
          marginRight: 12,
          textDecoration: "none",
          color: "#1976d2",
          fontSize: 14
        }}
      >
        {plz}
      </a>
    ))}
  </Box>
</Box>

    </>
  );
};

export default DownloadApp;
